import { buildModelManager } from "../builder.js";
const DefaultMicuDeviceLogSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  data: true,
  deviceId: true,
  logType: true,
  timestamp: true,
  updatedAt: true
};
const modelApiIdentifier = "micuDeviceLog";
const pluralModelApiIdentifier = "micuDeviceLogs";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMicuDeviceLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMicuDeviceLogSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceLogSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceLogSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceLogSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMicuDeviceLogSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "micuDeviceLogGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const MicuDeviceLogManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultMicuDeviceLogSelection,
  operations
);
export {
  DefaultMicuDeviceLogSelection,
  MicuDeviceLogManager
};
//# sourceMappingURL=MicuDeviceLog.js.map
